import { render, staticRenderFns } from "./AgreementPreviewTemplate.vue?vue&type=template&id=00735a71&scoped=true&"
import script from "./AgreementPreviewTemplate.vue?vue&type=script&lang=js&"
export * from "./AgreementPreviewTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00735a71",
  null
  
)

export default component.exports